<template>
  <div class="physical-assessment-check">
    <state-input
      :state="locations"
      :initial-value="state.subTypes"
      :synced-value="state.subTypes"
      :show-label="false"
      :multiple="true"
      width="220px"
      :disabled="readonly"
      placeholder="Any Location"
      class="location-input"
      @input="value => updateLocations(value)"
    />
  </div>
</template>

<script>
import { get } from 'lodash';
import StateInput from '~lib/common/components/StateInput.vue';

export default {
  name: 'physical-assessment-action',
  components: {
    StateInput,
  },
  props: [
    'states',
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        subTypes: [],
      },
    };
  },
  computed: {
    locations() {
      const state = this.states.find(s => s.id === 'physicalAssessmentLocations');
      return state ? {
        ...state,
        possibleValues: state.possibleValues.filter(value => value.key !== 'FULL_BODY')
      } : [];
    }
  },
  mounted() {
    this.syncState();
    this.update();
  },
  methods: {
    syncState() {
      const data = this.getData(this.ikey);
      this.state.subTypes = get(data, 'subTypes');
    },
    updateLocations(locationIds) {
      this.state.subTypes = locationIds;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'ASSESSMENT',
        id: 'PHYSICAL',
        subTypes: this.state.subTypes,
      });
      this.emitter.trigger('process', this.control);
    },
  },
}
</script>

<style scoped>

</style>